export interface WordSearchApiData {
  readonly id: string;
  readonly variant: string;
  readonly rounds: WordSearchRound[];
}

export interface WordSearchRound {
  readonly id: string;
  readonly brandName: string;
  readonly brandDescription: string;
  readonly products: WordSearchProduct[];
  readonly media: WordSearchMedia;
  readonly cpl: WordSearchCpl;
}

export interface WordSearchProduct {
  readonly name: string;
  readonly shortDescription: string;
  readonly longDescription: string;
  readonly title: string;
  readonly imageUrl: string;
}

export interface WordSearchMedia {
  readonly logoUrl: string;
  readonly imageUrl: string;
  readonly videoUrl: string;
}

export interface WordSearchCpl {
  readonly name: string;
  readonly title: string;
  readonly formPath: string;
  readonly tacPath: string;
  readonly brandName: string;
  readonly description: string;
  readonly imageUrl: string;
  readonly bid: number | null;
}

export interface Word {
  readonly content: string;
  readonly lettersSelected: number;
  readonly found: boolean;
}

export enum WordSearchFieldStatus {
  NONE = "NONE",
  SELECTED = "SELECTED",
  FOUND = "FOUND",
}

export enum WordSearchGameStatus {
  IDLE = "IDLE",
  STARTED = "STARTED",
  WON = "WON",
  LOST = "LOST",
}

export enum CplStatus {
  NONE = "NONE",
  ACCEPTED = "ACCEPTED",
  DENIED = "DENIED",
}

export interface WordSearchField {
  readonly index: number;
  readonly value: string;
  readonly status: WordSearchFieldStatus;
  readonly words: string[];
}

export interface WordSearchGameState {
  readonly words: Word[];
  readonly fieldsPerWords: WordFieldsMap;
  readonly fields: WordSearchField[];
  readonly status: WordSearchGameStatus;
  readonly cplStatus: CplStatus;
  readonly roundIndex: number | null;
}

// The indices of the puzzle that correspond to each word
export type WordFieldsMap = Record<string, number[]>;
